const setEmailStatus = function(state, status) {
  state.emailStatus = status
}

export default {
  setEmailStatus
}